import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecba9a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "improve-item-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "mentions" }
const _hoisted_6 = {
  key: 0,
  class: "count"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "8",
    height: "14",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.2",
      width: "8",
      height: "14",
      transform: "matrix(-1 0 0 1 8 0)",
      fill: "url(#pattern0)"
    }),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, [
        /*#__PURE__*/_createElementVNode("use", {
          "xlink:href": "#image0",
          transform: "scale(0.125 0.0714286)"
        })
      ]),
      /*#__PURE__*/_createElementVNode("image", {
        id: "image0",
        width: "8",
        height: "14",
        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAmElEQVQoFWNkwAJUeGxFWTg5tv9n+P+dCV0eLMnFsZ+BkcGYgYGBgxFZAVySgUGbgYHh6p9vPxzhCrBJ3vly+DVYAS5JkOmM+CRBCphArmVAshNkLLK7MHyBLAk24c/3H54gF4NMYeHi2A+yElkRYUfCVONyLDwcQAqxKUJRAFKkzGMlxsrFvQ/ss/8MZzEUwBVxcm8DRRYAiUZTfr5p+UMAAAAASUVORK5CYII="
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ScorecardSubpage = _resolveComponent("ScorecardSubpage")!

  return (_openBlock(), _createBlock(_component_ScorecardSubpage, {
    slide: _ctx.slideName,
    sticky: "",
    "show-header": !_ctx.embedded,
    title: "Your Customers Suggest"
  }, {
    default: _withCtx(() => [
      (_ctx.scorecard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBadges, (entry, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "improve-item",
                onClick: ($event: any) => (_ctx.goRoomToImproveDetail(entry))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(entry[1].label || entry[0]), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(entry[1].count) + " mention" + _toDisplayString(entry[1].count > 1 ? 's' : '') + " ", 1),
                    (entry[1].countUnseen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " +" + _toDisplayString(entry[1].countUnseen), 1))
                      : _createCommentVNode("", true),
                    (entry[1].percentage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass({ 'mentions-label': idx === 0 })
                        }, _toDisplayString(entry[1].percentage) + "% of detractor & passive feedback ", 3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_7
              ], 8, _hoisted_2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Loading, { loading: _ctx.loading }, null, 8, ["loading"])
    ], undefined, true),
    _: 1
  }, 8, ["slide", "show-header"]))
}